import React from "react";
import { Button, Column, Columns, Modal, Section, Title } from "@allxsmith/bestax-bulma";
import { createSetContactDataAction } from "../../actions/dataActions";
import { useDispatch } from "react-redux";

export default function TypeChangeModal({ open, setOpen, targetType }) {
  const dispatch = useDispatch();
  const onClose = () => {
    setOpen(false);
  };

  const onConfirm = () => {
    dispatch(createSetContactDataAction({ contact_type: targetType }));
    setOpen(false);
  };

  // TODO(bestax-migrate): `closeOnBlur` — bestax Modal background click closes when onClose is set; remove
  return (
    <Modal
      closeOnBlur
      active={open}
      onClose={() => {
        setOpen(false);
      }}
    >
      <Modal.Content>
        <Section style={{ backgroundColor: "white" }}>
          <Title className="is-centered">Are you sure?</Title>
          <Columns isMultiline>
            <Column>
              <p className="is-centered">
                You are updating an existing contact - Are you sure you want to
                change the contact type?
              </p>
              <p>
                {" "}
                If a contact is both a supplier and a customer, you should
                create two separate contacts.
              </p>
            </Column>
          </Columns>
          <Columns isMultiline>
            <Column>
              <Button
                color="danger"
                onClick={() => {
                  setOpen(false);
                }}
                isFullWidth
              >
                Cancel
              </Button>
            </Column>
            <Column>
              <Button color="success" onClick={onConfirm} isFullWidth>
                Confirm
              </Button>
            </Column>
          </Columns>
        </Section>
      </Modal.Content>
    </Modal>
  );
}
